import { Link } from 'react-router-dom';

export default function AboutSection() {
  return (
    <section className="w-full bg-primary-50/50 py-14 md:py-20">
      <div className="max-w-[800px] mx-auto px-4 md:px-6 text-center">
        <div className="mb-8 flex justify-center">
          <div className="w-20 h-20 rounded-full bg-primary-100 flex items-center justify-center">
            <i className="ri-file-list-3-line text-primary-500 text-3xl w-9 h-9 flex items-center justify-center"></i>
          </div>
        </div>

        <p className="text-xs font-semibold text-primary-500 uppercase tracking-widest mb-4">
          Czym jest Kakobuy Sheet?
        </p>

        <div className="space-y-6 text-left md:text-center">
          <p className="text-foreground-700 leading-relaxed text-[15px] md:text-base">
            <strong className="text-foreground-900">Kakobuy Spreadsheet 2026</strong> – Twój klucz do inteligentnych zakupów z Chin. Czy szukasz sprawdzonych produktów z chińskich platform, ale nie wiesz, od czego zacząć? <strong className="text-foreground-900">Kakobuy Sheet</strong> to innowacyjna baza danych stworzona dla europejskich kupujących, którzy cenią sobie czas i jakość.
          </p>
          <p className="text-foreground-700 leading-relaxed text-[15px] md:text-base">
            Nasza arkuszowa metoda organizacji znalezisk pozwala w kilka sekund odnaleźć topowe sneakersy, streetwear, elektronikę i akcesoria w najlepszych cenach. W przeciwieństwie do przypadkowego przeglądania setek ofert, <strong className="text-foreground-900">Kakobuy Spreadsheet</strong> gromadzi zweryfikowane linki, aktualne ceny i zdjęcia produktów w jednym miejscu.
          </p>
          <p className="text-foreground-700 leading-relaxed text-[15px] md:text-base">
            Niezależnie od tego, czy interesują Cię buty, bluzy, kurtki, czy perfumy – nasz system kategorii pomoże Ci trafić dokładnie tam, gdzie warto. Każdy produkt w <strong className="text-foreground-900">Kakobuy Sheet</strong> jest starannie posegregowany, co eliminuje ryzyko nietrafionych zakupów. Dołącz do tysięcy użytkowników z Polski i Europy, którzy już odkryli, jak proste mogą być zakupy z Chin.
          </p>
        </div>

        <div className="mt-8 flex justify-center">
          <Link
            to="/blog/kakobuy-spreadsheet-2026-guide"
            className="inline-flex items-center gap-2 px-7 py-3.5 bg-primary-500 text-background-50 text-sm font-semibold rounded-full hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            Więcej w artykule
            <i className="ri-arrow-right-up-line w-5 h-5 flex items-center justify-center"></i>
          </Link>
        </div>

        <p className="text-foreground-300 text-3xl mt-6">📊</p>
      </div>
    </section>
  );
}